import { render, staticRenderFns } from "./prospeccaoChartSideBar.vue?vue&type=template&id=46ba3dc7"
import script from "./prospeccaoChartSideBar.vue?vue&type=script&lang=js"
export * from "./prospeccaoChartSideBar.vue?vue&type=script&lang=js"
import style0 from "./prospeccaoChartSideBar.vue?vue&type=style&index=0&id=46ba3dc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports